import { Container } from "@mui/material";
import {Grid} from "@mui/material";
import {Typography} from "@mui/material";
import DrawerAppBar from "../components/nav";
import styled from "@emotion/styled";

const MainContainer = styled(Container)`
    padding-top:50px;
`
const Heading = styled(Typography)`
    font-family: 'ManjariBold';
    font-size: 50px;
    color: #2A3382;
    font-weight: 900;
    @media (max-width:767px){
        font-size:25px;
    }
    @media (max-width:1100px) and (min-width: 768px){
        font-size:40px;
    }
`
const P = styled(Typography)`
    font-family:ManjariRegular;
    font-size:16px;
    color:#27233A;
`
const TextGrid = styled(Grid)`

    display:flex;
    flex-direction:column;
`
const BuyBtn = styled.a`
    cursor: pointer;
    background: #FF9A55;
    font-size: 18px;
    color:#fff;
    font-family: 'ManjariBold';
    border-radius: 24px;
    padding: 18px 60px 12px 60px;
    @media (max-width:767px){
        font-size: 16px;
        padding: 10px 30px 5px 30px;
        margin-bottom: 10px;
    }
`
const ChartBtn = styled.a`
cursor: pointer;
    border:1px solid #27233A;
    font-size: 18px;
    font-family: 'ManjariBold';
    border-radius: 24px;
    padding:18px 60px 12px 60px;
    margin-left:14px;
    @media (max-width:767px){
        font-size: 16px;
        padding: 10px 30px 5px 30px;
        margin-bottom: 10px;
    }
`
const ArrowDiv = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    @media (max-width:767px){
        margin-top:10px;
    }
`
// const Footimg = styled.img`
//     // position: absolute;
//     // left: 40px;
//     // top: 135px;
//     z-index: -1;
//     width:130px;
//     height:130px;
// `
const Tizuimg = styled.img`
    max-width:100%;
`
const GridWrapper = styled(Grid)`
    display:flex;
    justify-content:space-between;
`
const Btndiv = styled.div`
    @media (max-width: 600px){
        margin:10px 0px;
    }
`
const ImageGrid = styled(Grid)`

`
const Wrapper = styled.div`
    margin:20px 0px;
    @media (max-width: 600px){
        margin:10px 0px;
    }
`
const Footimg = styled.img`
    width: 110px;
    position: absolute;
    z-index: -1;
    margin-top: -50px;
    margin-left: -37px;
`
export default function Firstsection(){
    return(
        <>
            
            <DrawerAppBar />
            <MainContainer id="buynow">
                <GridWrapper container>
                    <TextGrid item xs={12} sm={8} md={7} lg={6}>
                        <Wrapper>
                            <Footimg src="./assets/firstfoot.png" />
                            <Heading>
                            Tockenomics Redefined <br/>for Paw-some Gains!
                            </Heading>
                        </Wrapper>
                        <Wrapper>
                            <P>Welcome to the world of Shih Tzu, where the charm
                                and loyalty of the beloved dog breed inspire a
                                new era of decentralized finance!
                             </P>
                        </Wrapper>
                        <Wrapper>
                            <Btndiv>
                                <BuyBtn href="https://app.rocketswap.cc/exchange/swap/0x05231fAb6597e4388Ad86f7e9C276531dd8FAE0C" target="_blank">Buy now</BuyBtn>
                                <ChartBtn href="https://dexscreener.com/base/0x783542af1e7543f7c5f829b0f7be1bf777e1aeac" target="_blank">View chart</ChartBtn>
                            </Btndiv>
                        </Wrapper>
                        <Wrapper>
                            <ArrowDiv>
                                <img src="./assets/arrowimg.png" />
                            </ArrowDiv>
                        </Wrapper>
                    </TextGrid>
                    <ImageGrid item xs={12} sm={4}  md={4}>
                        <Tizuimg src="./assets/shih.png" alt="" />
                    </ImageGrid>
                </GridWrapper>
            </MainContainer>
        </>
    );
}